import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiServices } from './api.services';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private apiService: ApiServices) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                console.log("===========401========");
                this.apiService.onLogOut('Session Expired!', 'danger');
                //location.reload(true);
            } else if (err.status != 200) {
                this.apiService.sendTextMessage("Server not responded", 'danger');
            }
            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}